module.exports = __webpack_public_path__ + "img/17342735.0243021d.png";